/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export enum GalleryLayoutID {
  MainImage = 1,
  Grid = 2,
}

export enum ImageRatio {
  AUTO = -1,
  THREE_BY_TWO = 0,
  FOUR_BY_THREE = 1,
  ONE_BY_ONE = 2,
  THREE_BY_FOUR = 3,
  TWO_BY_THREE = 4,
}

export const getResponsiveLayoutCustomCssVars = ({styleParams, isMobile}: CustomCssVarsFnParams) => {
  let columnLayout;
  let shouldWrap;

  let widthImageRatio;
  let heightImageRatio;

  switch (styleParams.numbers.productPage_galleryImageRatio) {
    case ImageRatio.THREE_BY_TWO:
      widthImageRatio = 3;
      heightImageRatio = 2;
      break;
    case ImageRatio.FOUR_BY_THREE:
      widthImageRatio = 4;
      heightImageRatio = 3;
      break;
    case ImageRatio.THREE_BY_FOUR:
      widthImageRatio = 3;
      heightImageRatio = 4;
      break;
    case ImageRatio.TWO_BY_THREE:
      widthImageRatio = 2;
      heightImageRatio = 3;
      break;
    case ImageRatio.ONE_BY_ONE:
    case ImageRatio.AUTO:
    default:
      widthImageRatio = 1;
      heightImageRatio = 1;
      break;
  }

  if (isMobile) {
    columnLayout = 'column';
    shouldWrap = 'nowrap';
  } else {
    columnLayout = styleParams.booleans.productPage_flipColumns ? 'row-reverse' : 'row';
    shouldWrap = 'wrap';
  }

  return {
    mediaColumnDirection: columnLayout,
    shouldWrapResponsiveFlexBox: shouldWrap,
    widthImageRatio,
    heightImageRatio,
  };
};

export const getResponsiveLayoutShouldRenderVars = ({booleans, isMobile, numbers}: ShouldRenderVarsFnParams) => {
  return {
    shouldRenderGridLayout: !isMobile && numbers.productPage_galleryLayoutID === GalleryLayoutID.Grid,
    shouldRenderMainImageLayout: isMobile || numbers.productPage_galleryLayoutID === GalleryLayoutID.MainImage,
    shouldRenderResponsiveLayoutNavigation: booleans.productPage_navigation || isMobile,
  };
};
